import Guid from "~/helpers/guid";
import License from "../license";
import { LicenseStepModelType } from "../../enums/licenseStepModelType";
import LicenseStep from "./licenseStep";
import RegistrationStep from "./registrationStep";
import MaintenanceStep from "./maintenanceStep";
import RenewalStep from "./renewalStep";
import PublicProfile from "../../../../common/models/publicProfile/publicProfile";

export default class LicenseStepFactory {
  static create(
    license: License | PublicProfile,
    stepType: LicenseStepModelType
  ): LicenseStep {
    let step: LicenseStep = null;

    switch (stepType) {
      case LicenseStepModelType.registration:
        step = new RegistrationStep(license);
        break;
      case LicenseStepModelType.maintenance:
        step = new MaintenanceStep(license);
        break;

      case LicenseStepModelType.renewal:
        step = new RenewalStep(license);
        break;
      default:
        break;
    }

    step.defineProperty("client_id", Guid.create());
    step.defineProperty("description", "");
    step.defineProperty("sort_order", license.nextSortOrderFor(step.rootName));
    step.parent = license;
    return step;
  }
}
